import { render } from "./RiderActivities.vue?vue&type=template&id=c6e8f430"
import script from "./RiderActivities.vue?vue&type=script&lang=js"
export * from "./RiderActivities.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__